const CUSTOM_ERROR_MAP: Record<string, string> = {
  "0x30cd7471": "Not the token owner",
  "0x788a686f": "Wrong payment amount",
  "0x52df9fe5": "Sold out",
  "0x888e58a8": "Bad quantity",
  "0xf9be60a2": "Already active",
  "0x80cb55e2": "Not active",
  "0x21a9b143": "Invalid tier",
  "0x4f936278": "Invalid fuse",
  "0xd92e233d": "Zero address not allowed",
  "0xa741a045": "Already set",
  "0x589ed34b": "Mint closed",
  "0xa38ca3d9": "Transfer to zero address",
  "0xea8e4eb5": "Not authorized",
  "0xb1d04f08": "Token does not exist",
  "0x91d01199": "Only wallets allowed",
  "0x0ef702e2": "Rarity not set for this cat",
  "0x8fd4c5b1": "Rarity already set",
  "0x90c64482": "Bad rarity count",
  "0x8ce13130": "Bad URI count",
  "0x09bde339": "Invalid Merkle proof",
  "0x1c8b6259": "Metadata root not set",
  // OpenZeppelin ERC20 errors
  "0xfb8f41b2": "Token allowance too low, please approve first",
  "0xe450d38c": "Token balance insufficient",
  "0x5274afe7": "Token transfer failed",
};

function extractSelector(data?: string): string | null {
  if (!data || !data.startsWith("0x") || data.length < 10) return null;
  return data.slice(0, 10).toLowerCase();
}

export function formatContractError(err: unknown): string {
  if (err && typeof err === "object") {
    const data = (err as { data?: string }).data ?? (err as { error?: { data?: string } }).error?.data;
    const selector = extractSelector(data);
    if (selector && CUSTOM_ERROR_MAP[selector]) {
      return CUSTOM_ERROR_MAP[selector];
    }

    const reason = (err as { reason?: string }).reason;
    if (reason) return reason;

    const message = (err as { message?: string }).message;
    if (message) return message;
  }
  return "Transaction failed";
}
